/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { UpdateEtcCardHolder200ResponseHolder } from './update-etc-card-holder200-response-holder';
// May contain unused imports in some cases
// @ts-ignore
import { UpdateEtcCardHolder200ResponseUserAccountGroup } from './update-etc-card-holder200-response-user-account-group';

/**
 * 
 * @export
 * @interface UpdateEtcCardHolder200Response
 */
export interface UpdateEtcCardHolder200Response {
    /**
     * ETC card ID
     * @type {string}
     * @memberof UpdateEtcCardHolder200Response
     */
    'cardId': string;
    /**
     * Card name (max 64 characters)
     * @type {string}
     * @memberof UpdateEtcCardHolder200Response
     */
    'cardLabel': string;
    /**
     * Card status
     * @type {string}
     * @memberof UpdateEtcCardHolder200Response
     */
    'cardStatus': UpdateEtcCardHolder200ResponseCardStatusEnum;
    /**
     * 
     * @type {UpdateEtcCardHolder200ResponseHolder}
     * @memberof UpdateEtcCardHolder200Response
     */
    'holder': UpdateEtcCardHolder200ResponseHolder;
    /**
     * 
     * @type {UpdateEtcCardHolder200ResponseUserAccountGroup}
     * @memberof UpdateEtcCardHolder200Response
     */
    'userAccountGroup'?: UpdateEtcCardHolder200ResponseUserAccountGroup | null;
    /**
     * User account ID
     * @type {string}
     * @memberof UpdateEtcCardHolder200Response
     */
    'userAccountId': string;
    /**
     * Last four digits of the ETC card ID for display
     * @type {string}
     * @memberof UpdateEtcCardHolder200Response
     */
    'etcIdLastFourDigits'?: string | null;
}

export const UpdateEtcCardHolder200ResponseCardStatusEnum = {
    issuing: 'ISSUING',
    active: 'ACTIVE',
    deactivated: 'DEACTIVATED'
} as const;

export type UpdateEtcCardHolder200ResponseCardStatusEnum = typeof UpdateEtcCardHolder200ResponseCardStatusEnum[keyof typeof UpdateEtcCardHolder200ResponseCardStatusEnum];


